import React from 'react'
import Typography from '../../Typography'
import styles from '../dropdown.module.scss'

const DropdownText = ({ children, ...rest }) => (
  <Typography
    variant={'p7'}
    className={styles['text']}
    color={'text-secondary'}
    {...rest}
  >
    {children}
  </Typography>
)

export default DropdownText
